import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import FlashlightEffect from './FlashlightEffect';
import './About.css';

gsap.registerPlugin(ScrollTrigger);

const About = () => {
  const aboutRef = useRef(null);

  useEffect(() => {
    if (!aboutRef.current) return;
    gsap.fromTo(
      aboutRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1.2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: aboutRef.current,
          start: "top 80%",
          end: "bottom 20%",
          toggleActions: "play none none reverse"
        }
      }
    );
  }, []);

  return (
    <>
      <FlashlightEffect aboutRef={aboutRef} />
      <section id="about" className="about-section">
        <div className="about-container" ref={aboutRef}>
          <p className="about-statement">
            I'm a third-year UX design student who’s still learning — and genuinely excited about it. I care about creating digital experiences that feel intuitive, thoughtful, and real. My approach is grounded in curiosity, empathy, and asking the right questions. I might not know everything yet, but I’m focused, adaptable, and always looking to grow into a designer who solves problems that actually matter.
          </p>
        </div>
      </section>
    </>
  );
};

export default About;